import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const footer = () => {

	let el = document.querySelector('[data-animation="footer"]')

	if (!el || window.innerWidth < 782) return

	gsap.fromTo(el, {
		y: '-33%',
	}, {
		y: 0,
		ease: 'none',
		scrollTrigger: {
			trigger: el.parentElement,
			start: 'top bottom',
			end: 'bottom bottom',
			scrub: true,
			// markers: true,
		}
	})

}

export default () => { }